export default {
  install (Vue) {
    Vue.mixin({
      data () {
        return {
          apiWatchers_: {},
          apiMainWatchers_: {}
        }
      },
      beforeDestroy () {
        this.APIUnWatchAll()
        this.APIUnWatchMainAll()
      }
    })
    Object.defineProperties(Vue.prototype, {
      API: {
        get () {
          return (Url) => {
            this.APICheckUpdate(this.APIGet(Url))
            return this.$store.getters['api/url'](Url)
          }
        }
      },
      APIPromise: {
        get () {
          return (Url) => {
            return new Promise(resolve => {
              let watcher = this.APIWatch(Url, (result) => {
                if (!result.isLoading) {
                  resolve(result)
                  this.$nextTick(() => {
                    this.APIUnWatch(watcher.id)
                  })
                }
              })
            })
          }
        }
      },
      APIWatch: {
        get () {
          return (Url, Callback) => {
            // api
            let api = this.APIGet(Url)
            // watcher
            let watcher = {
              unWatcher: this.$store.watch((state, getters) => getters['api/url'](api.params.url), Callback, { immediate: true }),
              id: `${Url}-${(new Date()).getTime()}-${_.random(0, 100000)}`
            }
            this.APICheckUpdate(api)
            this.apiWatchers_[watcher.id] = watcher
            return watcher
          }
        }
      },
      APIGet: {
        get () {
          return (Url) => {
            let isNew = false
            let params = { key: Url.slice(0, Url.indexOf('/')), url: Url, uid: this._uid }
            this.apiMainWatchers_[params.url] = params
            // main
            if (!this.$store.getters['api/main'](params.key)) {
              this.$store.commit('api/create', params)
            } else {
              this.$store.commit('api/addWatcher', params)
            }
            // url
            if (!this.$store.getters['api/url'](params.url)) {
              isNew = true
              this.$store.commit('api/createUrl', params)
            }
            return {
              isNew: isNew,
              params: params,
              store: this.$store.getters['api/url'](params.url),
              main: this.$store.getters['api/main'](params.key)
            }
          }
        }
      },
      APICheckUpdate: {
        get () {
          return (Api) => {
            if (
              Api.isNew ||
              (Api.store.lastUpdate && !Api.store.isLoading && Api.main.lastUpdate > Api.store.lastUpdate)
            ) {
              this.$store.dispatch('api/load', Api.params.url)
            }
          }
        }
      },
      APIUnWatch: {
        get () {
          return (ID) => {
            if (this.apiWatchers_[ID]) {
              this.apiWatchers_[ID].unWatcher()
              delete this.apiWatchers_[ID]
            }
          }
        }
      },
      APIUnWatchAll: {
        get () {
          return _ => {
            this.$_.each(this.apiWatchers_, item => {
              item.unWatcher()
            })
            this.apiWatchers_ = {}
          }
        }
      },
      APIUnWatchMainAll: {
        get () {
          return _ => {
            this.$_.each(this.apiMainWatchers_, params => this.$store.commit('api/removeWatcher', params))
            this.apiMainWatchers_ = {}
          }
        }
      },
      APIUpdate: {
        get () {
          return (Url, UpdateStore) => {
            let updateStore = (UpdateStore) ? UpdateStore.split(',') : undefined
            if (updateStore) {
              updateStore.forEach(key => {
                this.$store.dispatch('api/update', key)
              })
            } else if (Url.indexOf('api/') !== -1) {
              let url = Url.slice(Url.indexOf('api/') + 4)
              this.$store.dispatch('api/update', url.slice(0, url.indexOf('/')))
            }
          }
        }
      }
    })
  }
}
